import { render, staticRenderFns } from "./OpticalTweezersViz.vue?vue&type=template&id=405c9385&scoped=true"
import script from "./OpticalTweezersViz.vue?vue&type=script&lang=js"
export * from "./OpticalTweezersViz.vue?vue&type=script&lang=js"
import style0 from "./OpticalTweezersViz.vue?vue&type=style&index=0&id=405c9385&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c9385",
  null
  
)

export default component.exports